"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { Path, UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Textarea,
} from "..";
type CustomTextAreaProps<TFormValues extends Record<string, any>> = {
  form: UseFormReturn<TFormValues>;
  name: Path<TFormValues>;
  label?: string;
  description?: string;
  helpText?: string;
  className?: string;
};
export type FormTextAreaProps<TFormValues extends Record<string, any>> =
  CustomTextAreaProps<TFormValues> &
    Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, "form" | "name">;
export function FormTextArea<TFormValues extends Record<string, any>>({
  form,
  name,
  label,
  description,
  required = false,
  className,
  placeholder,
  ...props
}: FormTextAreaProps<TFormValues>) {
  return (
    <div className={className}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label ? (
              <FormLabel className="tw:gap-0">
                {label}
                {required ? <span className="tw:text-destructive">*</span> : ""}
              </FormLabel>
            ) : null}
            <FormControl>
              <Textarea
                {...field}
                placeholder={placeholder}
                required={required}
                {...props}
              />
            </FormControl>
            {description ? (
              <FormDescription>{description}</FormDescription>
            ) : null}
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
